// Include editor required mixin functionality. A mixin named "FooXxxMixin" will mix with the aptly named
// class "Foo" (Xxx could be "Sync", but it could also be empty).
require([
    // The order below matters! Possibly only if the mixins depend on each other like ImprovedModelSyncMixin and ExperienceModelEditorMixin. See MOS-2384.
    "zbone/ImprovedModelSyncMixin",
    "ui/experience/widgets/AbstractWidgetEditorMixin",
    "ui/experience/SceneEditorMixin",
    "ui/experience/ExperienceModelEditorMixin",
    "ui/experience/action/ActionEditorMixin",
    "ui/experience/widgets/WidgetTypesEditorMixin",
    "ui/settings/CompanySettingsEditorMixin",
    "ui/experience/widgets/socialSharingWidget/SocialSharingWidgetViewEditorMixin",
    "ui/experience/widgets/textWidget/TextWidgetViewEditorMixin",
    "ui/experience/widgets/textEnhancedWidget/TextWidgetViewEditorMixin",
    "ui/experience/widgets/htmlWidget/HtmlWidgetViewEditorMixin",
    "ui/groups/GroupModelEditorMixin",
    "ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetModelEditorMixin",
    "ui/experience/widgets/button/ButtonWidgetModelEditorMixin",
    "ui/experience/widgets/embedWidget/EmbedWidgetModelEditorMixin",
    "ui/experience/widgets/imageWidget/ImageWidgetModelEditorMixin",
    "ui/experience/widgets/imageWidget/ImageWidgetViewEditorMixin",
    "ui/experience/widgets/lineWidget/LineWidgetModelEditorMixin",
    "ui/experience/widgets/lineWidget/LineWidgetViewEditorMixin",
    "ui/experience/widgets/linkWidget/LinkWidgetModelEditorMixin",
    "ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetViewEditorMixin",
    "ui/experience/widgets/shapeWidget/ShapeWidgetModelEditorMixin",
    "ui/experience/widgets/socialSharingWidget/SocialSharingWidgetModelEditorMixin",
    "ui/experience/widgets/textEnhancedWidget/TextWidgetModelEditorMixin",
    "ui/experience/widgets/textWidget/TextWidgetModelEditorMixin",
    "ui/experience/widgets/youtubeWidget/YouTubeWidgetModelEditorMixin",
    "ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetViewEditorMixin",
    "ui/experience/widgets/compositeWidget/CompositeWidgetModelEditorMixin"
]);



// WEBPACK FOOTER //
// ./src/editor/editor-mixins.js